import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../envisia/auth/axios-http-client';
import {environment} from '../../../environments/environment';
import {ArticleMultilayerPlan} from '../../envisia/article/main/multilayer-plan/article-multilayer-plan.models';
import {MultilayerPlanUpdateNameForm} from './multilayer-plan.models';
import {queryKey} from './multilayer-plan-query-keys';

interface Props {
  onSuccess: () => void;
}

export function useMultilayerPlanUpdateNameMutation({onSuccess}: Props) {
  const queryClient = useQueryClient();
  const {mutate, isPending} = useMutation({
    mutationFn: (form: MultilayerPlanUpdateNameForm) =>
      AxiosHttpClient.put<ArticleMultilayerPlan>(
        `${environment.apiv4uri}multilayerplan/${form.shared_id}/name`,
        form),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: queryKey.lists()});
      onSuccess();
    },
  });
  return {
    updateNameMutate: (form: MultilayerPlanUpdateNameForm) => mutate(form),
    updateNameIsPending: isPending,
  };
}
